module.exports = __webpack_public_path__ + "static/media/HKGrotesk-Black.0352ab32.ttf";